import { render, staticRenderFns } from "./payment-method-accordion.vue?vue&type=template&id=17c76fc8&scoped=true&"
import script from "./payment-method-accordion.ts?vue&type=script&lang=ts&"
export * from "./payment-method-accordion.ts?vue&type=script&lang=ts&"
import style0 from "./payment-method-accordion.scss?vue&type=style&index=0&id=17c76fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c76fc8",
  null
  
)

export default component.exports